import React from "react";
import {
  HomePageProgressButton,
  HomePageProgressCard,
} from "./HomePageProgress";
import { getLessonToResume } from "@utils";
import { graphql, useStaticQuery } from "gatsby";

type HomePageCourseProgressProps = {
  courseId: string;
  completedTaskIds: string[];
};

export function HomePageCourseProgress({
  courseId,
  completedTaskIds,
}: HomePageCourseProgressProps) {
  const { tutorials, certifications } =
    useStaticQuery<Queries.HomePageCourseProgressQuery>(graphql`
      query HomePageCourseProgress {
        tutorials: allCourse {
          nodes {
            slug
            progressId
            title
            description
            type
            thumb {
              src
              alt
            }
            lessons {
              slug
              tasks {
                id
              }
            }
          }
        }
        certifications: allCertification {
          nodes {
            title
            criteria
          }
        }
      }
    `);

  const tutorial = tutorials.nodes.find((node) => node.progressId === courseId);

  if (!tutorial) {
    throw new Error("Tutorial not found");
  }

  const certification = certifications.nodes.find((node) =>
    node.criteria.includes(courseId)
  );

  const { title, type, thumb, lessons } = tutorial;

  const lessonToResume = getLessonToResume(lessons, completedTaskIds);

  return (
    <HomePageProgressCard
      type={certification ? "Certification" : type ?? undefined}
      title={certification?.title || title}
      subtitle={certification && title}
      thumb={thumb}
    >
      <HomePageProgressButton to={`/${lessonToResume.slug}`}>
        Resume progress
      </HomePageProgressButton>
    </HomePageProgressCard>
  );
}
